export const formatValue = (format, value) => {
  // Verificar se value é null ou undefined
  if (value === null || value === undefined || value === "") {
    return "";
  }

  // Converter para string se necessário
  const stringValue = String(value);

  switch (format) {
    case "cnpj":
      try {
        return stringValue.replace(
          /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
          "$1.$2.$3/$4-$5"
        );
      } catch (error) {
        return stringValue;
      }
    case "cpf":
      try {
        return stringValue.replace(
          /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
          "$1.$2.$3-$4"
        );
      } catch (error) {
        return stringValue;
      }
    case "data":
      try {
        const novaData = new Date(stringValue);
        if (isNaN(novaData.getTime())) return "";
        novaData.setHours(novaData.getHours() + 3);
        const ISOdate = novaData.toISOString();
        return new Date(ISOdate).toLocaleDateString();
      } catch (error) {
        return "";
      }

    case "periodo":
      // Formato MM/YYYY - preserva apenas mês e ano, sem adicionar dia
      try {
        const novaData = new Date(stringValue);
        if (isNaN(novaData.getTime())) return "";
        
        // Extrair apenas mês e ano (preservar formato original)
        const mes = String(novaData.getMonth() + 1).padStart(2, '0');
        const ano = novaData.getFullYear();
        
        return `${mes}/${ano}`;
      } catch (error) {
        return "";
      }

    case "number":
      try {
        const number = parseFloat(stringValue).toFixed(2);
        return number.replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } catch (error) {
        return "";
      }

    case "cep":
      try {
        return stringValue.replace(/^(\d{5})(\d{3})$/, "$1-$2");
      } catch (error) {
        return stringValue;
      }

    default:
      return stringValue;
  }
};

export const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "") {
    return "R$ 0,00";
  }
  const formatted = formatValue("number", value);
  return `R$ ${formatted}`;
};